import React, { Component } from 'react'
import Link from 'gatsby-link'
import { withPrefix } from 'gatsby-link'
import Img from 'gatsby-image'

import './background.css'

class Background extends Component {

  createNameDisplay(name) {
    let nameDisplay = null;

    if (this.props.shouldDisplayName) {
      nameDisplay = (
        <div className = "name-display">
          {name}
        </div>
      );
    }

    return nameDisplay;
  }

  render () {
    let name = this.props.name;
    let href = this.props.href;
    let nameDisplay = this.createNameDisplay(name);

    return (
      <div style={{opacity: this.props.isVisible ? 1 : 0, transition: 'opacity 200ms ease-in-out'}}>

        <div className={"darkened " + (this.props.isDarkened ? "active" : "")}>
        </div>

          <Img
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100vh'}}
            sizes = {this.props.sizes}>
          </Img>

          {nameDisplay}

      </div>
    );
  }
}


export default {Background}



// WEBPACK FOOTER //
// ./src/components/Background/background.js